import { getEmbeddingProviderSlug } from "@arti/ai-models-config/embeddingProvider";
import { skillMeshEmbeddingConfig } from "@arti/ai-models-config/skillMeshEmbeddingConfig";

import { PROVIDER_LABELS } from "./providers";

/**
 * The provider key Skill Mesh semantic search bills to. Derived from the
 * configured embedding model so a model change moves the signifier with it.
 */
export const EMBEDDING_PROVIDER = getEmbeddingProviderSlug(
  skillMeshEmbeddingConfig.model,
);

export const EMBEDDING_PROVIDER_LABEL: string =
  PROVIDER_LABELS[EMBEDDING_PROVIDER] ?? EMBEDDING_PROVIDER;

export const EMBEDDING_KEY_MISSING_TITLE = "Embedding key missing";

export const EMBEDDING_KEY_MISSING_MESSAGE = `Semantic search is off for this organization. The ${EMBEDDING_PROVIDER_LABEL} key powers embeddings for Skill Mesh search; until it is configured, searches run keyword-only.`;

export const EMBEDDING_KEY_PRESENT_MESSAGE = `Embeddings: ${EMBEDDING_PROVIDER_LABEL} key configured.`;

/** Appended to the provider row that semantic search depends on. */
export const EMBEDDING_ROW_SUFFIX = "used for embeddings";

export interface EmbeddingKeyCandidate {
  has_key: boolean;
  provider: string;
}

export function hasEmbeddingKey(
  keys: readonly EmbeddingKeyCandidate[],
): boolean {
  return keys.some((key) => key.provider === EMBEDDING_PROVIDER && key.has_key);
}

/** Row label for a provider, marking the one embeddings depend on. */
export function providerRowLabel(provider: string): string | undefined {
  if (provider !== EMBEDDING_PROVIDER) {
    return undefined;
  }
  return `${PROVIDER_LABELS[provider] ?? provider} — ${EMBEDDING_ROW_SUFFIX}`;
}
